import * as Sentry from "@sentry/react";

export type Eox7Endpoint = "documents/me" | "open-token" | "view-token";

const fieldOf = (value: unknown, key: string): unknown =>
	typeof value === "object" && value !== null && key in value
		? (value as Record<string, unknown>)[key]
		: undefined;

/** The HTTP status of a failed eox7 request, or a string such as `"TIMEOUT_ERROR"`. */
export const eox7ErrorStatus = (error: unknown): unknown =>
	fieldOf(error, "status");

const HTTP_FORBIDDEN = 403;

/** eox7 won't make the caller a report user in this domain — no access, not a failure. */
export const isEox7Forbidden = (error: unknown) =>
	eox7ErrorStatus(error) === HTTP_FORBIDDEN;

/** Reports the status and eox7's `traceId`, which locates the request in eox7's logs. */
export const reportEox7Error = (error: unknown, endpoint: Eox7Endpoint) => {
	Sentry.captureException(error, {
		extra: {
			endpoint,
			status: eox7ErrorStatus(error),
			traceId: fieldOf(fieldOf(error, "data"), "traceId"),
		},
	});
};
